import { createApp } from 'vue';
import App from './App.vue';

import '@fortawesome/fontawesome-free/css/all.css';
import { setupI18n } from './i18n.js';
import registerComponents from './register_controls.js';
import router from './router.js';
import store from './store/index.js';
import './store/wiring.js';
import FloatingVue from 'floating-vue';
import 'floating-vue/dist/style.css';
import './style.scss';

// Check if an app is already mounted
const appElement = document.getElementById('app');
if (appElement.__vue_app__) {
    appElement.__vue_app__.unmount(); // Unmount the previous app
}

async function bootstrap() {
    const app = createApp(App);
    app.use(FloatingVue);
    app.use(store);
    await setupI18n(app);
    await registerComponents(app);
    app.use(router);
    app.mount('#app');
}

bootstrap();
